export const currentViewName = (location) => {
  switch (location.pathname) {
    case '/orders/open':
      return 'Open';
    case '/orders/completed':
      return 'Completed';
    default:
      return 'Active Listings';
  }
};

export const ACTIVE_LISTINGS = 'Active Listings';
export const INVENTORY = 'Inventory';
export const ORDERS = 'Orders';
